import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragulaModule } from 'ng2-dragula';
import { MaterialModule } from './material.module';
import { ArticleModule } from './article/article.module';
import { AuthorizeDirective } from './authorize.directive';
import { AutoScrollDirective } from './auto-scroll.directive';
import { ClipboardCopyComponent } from './clipboard-copy/clipboard-copy.component';
import { ClipboardDirective } from './clipboard.directive';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { DynamicFormModule } from './dynamic-form/dynamic-form.module';
import { FileDropDirective } from './file-drop.directive';
import { MarkdownPipe } from './markdown.pipe';
import { PageModule } from './page/page.module';
import { SimpleMDEComponent } from './simple-mde/simple-mde.component';
import { SimpleMDEDirective } from './simple-mde/simple-mde.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MaterialModule,
    FlexLayoutModule,
    DragulaModule,
    DynamicFormModule,
    ArticleModule,
    PageModule
  ],
  declarations: [
    SimpleMDEDirective,
    SimpleMDEComponent,
    MarkdownPipe,
    AuthorizeDirective,
    FileDropDirective,
    ConfirmationDialogComponent,
    ClipboardDirective,
    ClipboardCopyComponent,
    AutoScrollDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MaterialModule,
    FlexLayoutModule,
    DragulaModule,
    DynamicFormModule,
    ArticleModule,
    PageModule,
    SimpleMDEDirective,
    SimpleMDEComponent,
    MarkdownPipe,
    AuthorizeDirective,
    FileDropDirective,
    ConfirmationDialogComponent,
    ClipboardDirective,
    ClipboardCopyComponent,
    AutoScrollDirective
  ],
  entryComponents: [
    ConfirmationDialogComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/shared.module.ts